import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { ButtonBase, Typography, useTheme } from "@mui/material";
import FlexBox from "../../../../components/layouts/Flexbox";
import { APP_COLORS } from "../../../../enums";
import { TimeChipProps } from "./types";
import { getSlotTimeLabel } from "./utils";

export function TimeChip({ slot, selected = false, onClick }: TimeChipProps) {
  const theme = useTheme();
  const timeLabel = getSlotTimeLabel(slot);
  const Icon = selected ? CheckCircleOutlineIcon : AccessTimeOutlinedIcon;

  return (
    <ButtonBase
      onClick={onClick}
      aria-pressed={selected}
      sx={{
        borderRadius: 1.5,
        border: `1px solid ${selected ? APP_COLORS.primary : APP_COLORS.greyLight6}`,
        bgcolor: selected ? "primary.main" : "transparent",
        color: selected ? "primary.contrastText" : "text.primary",
        transition: theme.transitions.create(["border-color", "background-color", "color"], {
          duration: theme.transitions.duration.shorter,
        }),
        "&:hover": {
          border: `1px solid ${APP_COLORS.primary}`,
          bgcolor: selected ? "primary.dark" : "transparent",
          color: selected ? "primary.contrastText" : "primary.main",
        },
      }}
    >
      <FlexBox alignItems="center" gap={0.625} px={0.875} py={0.5}>
        <Icon sx={{ fontSize: 14, color: "inherit", flexShrink: 0 }} />
        <Typography
          variant="caption"
          color="inherit"
          fontWeight={600}
          lineHeight={1.2}
          fontSize={11}
          whiteSpace="nowrap"
        >
          {timeLabel}
        </Typography>
      </FlexBox>
    </ButtonBase>
  );
}
